function GetPerspectiveCardPrice() {

    var Amount = $("#ForMemberCardAmount").val();
    var OldAmount = $("#ForMemberCardOldAmount").val();
    var MemberCardGroupID = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode = $("#ForMemberCardCurrencySymbol").val();

    if (Amount != undefined &&
        OldAmount != undefined &&
        MemberCardGroupID != undefined &&
        ForMemberCardCurrencyCode != undefined &&
        MemberCardGroupID != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallCountryCode").val() + "-" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount + "&AmountOld=" + OldAmount + "&MemberCardGroupID=" + MemberCardGroupID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {

                    $(".RPrice").html(ForMemberCardCurrencyCode + " " + dt.TotalAmount);

                    $(".PerspectiveCardPrice").css("display", "inline-block");
                }
            }
        });
    }
}

// Mini Basket Style
function hideBasket() {
    $(".SepetProducts").stop().animate(200, function () {
        $(".SepetProducts").stop().hide();
    });
}

function setContentHeight() {
    var headerHeight = $("header").height();
    var headerTop = $("header").css("top").replace("px", "");
    var deviceHeight = $(window).height();
    var BasketButtonHeight = $(".SepetProducts .PriceAndButton").height();
    var CardTitleHeight = $(".SepetProducts .CartTitle").height();
    var MarginAndPadding = 80;
    var MiniBasketHeight = $(window).height() - headerHeight - headerTop;

    if ($(window).width() < 991) {
        $(".SepetProducts").css("width", $(window).width());
    }

    //var ContentHeight = MiniBasketHeight / 100 * 45;
    var ContentHeight = deviceHeight - headerHeight - headerTop - BasketButtonHeight - CardTitleHeight - MarginAndPadding;

    if (isMobileResolution() && $(window).height() > 600) {
        ContentHeight = MiniBasketHeight / 100 * 59;
    }
    else if ($(window).height() > 600) {
        ContentHeight = MiniBasketHeight / 100 * 45;
    }

    $(".BasketCenterContent").height(ContentHeight);
    $(".BasketCenterContent").css("max-height", ContentHeight);

    if (isMobileResolution()) {
        MiniBasketHeight = $(window).height() - 200 - headerHeight + $(".ProductOptions .BasktButtons").height() + 50;
    }

    $(".SepetProducts").height(MiniBasketHeight);
    $(".SepetProducts").css("max-height", MiniBasketHeight);
}

function toggleBasket() {
    if ($(".SepetProducts").is(":visible")) {
        
        $(".SepetProducts").stop().animate({ height: 'hide' }, 200, function () {
            $(".SepetProducts").hide();  
            $("body").removeClass("BasketDropped BackDropped no-scroll");
        });
    } else {
        
        $(".SepetProducts").stop().animate({ height: 'show' }, 200, function () {
            setContentHeight();
            $("body").addClass("BasketDropped no-scroll");
        });
    }
}
// End Mini Basket Style

// Mini Basket Operations
function RemoveFromCardForMiniCard(id, langId, allRemove) {
    basketElement = $("#UserMenus .SepetProducts .BasketContainer");
    GenerateLocalLoading(basketElement, "show");

    $.ajax({
        type: 'get',
        url: getRequestRoute() + '/p/Cart/RemoveFromCart',
        data: 'id=' + id + "&langID=" + langId + allRemove,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {
                //$.ajax({
                //    type: 'get',
                //    url: getRequestRoute() + "/p/Cart/GetSepetIcerik",
                //    data: "",
                //    async: false,
                //    contentType: "application/json; charset=utf-8",
                //    dataType: 'text',
                //    success: function (dt) {
                //        $("#UserMenus  #UserAndBasket").html(dt);
                //        toggleBasket();
                //        setContentHeight();
                //    },
                //    error: function () {
                //        GenerateLocalLoading(basketElement, "hide");
                //    }
                //});

                GetSepetIcerik(function (dt) {
                    $("#UserMenus  #UserAndBasket").html(dt);
                    toggleBasket();
                    setContentHeight();

                    GenerateLocalLoading(basketElement, "hide");
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            GenerateLocalLoading(basketElement, "hide");
        }
    });
}

function GetSepetIcerik(callback) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + "/p/Cart/GetSepetIcerik",
        data: "",
        async: true,
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: 'text',
        success: function (dt) {
            //$("#UserAndBasket").html(dt);

            if ($("#LangSelectionNeed").length > 0) {
                ShowLangAreaForChange();
            }

            if ($("#WindowSizeNotSetted").length > 0) {
                SetWindowSize();
            }

            //GetPerspectiveCardPrice();

            callback(dt);

            //if (openBasket != null && openBasket != undefined && openBasket) {
            //    toggleBasket();
            //}
        }
    });
}
// End Mini Basket Operations

// Product List

// End Product List

// Product Detail
function AddToCard(param, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddToCart",
        data: param,
        dataType: 'json',
        async: true,
        success: function (dt) {

            if (dt.JsonRs != null && dt.JsonRs != undefined && dt.JsonRs != "") {
                window.dataLayer = window.dataLayer || [];
                dataLayer.push({
                    "event": "eec.add",
                    "ecommerce": {
                        "add": {
                            "actionField": {
                                "list": "Product Detail"
                            },
                            "products": [JSON.parse(dt.JsonRs)]
                        }
                    }
                });
            }

            callback(dt);
        }
    });
}
// Product Detail

// Combine
function AddCombineToBasket(basketButton, NormalText, data) {
    GenerateLocalLoading($(".ProductDetail.Combines"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/AddCombineToCart",
        data: data,
        dataType: 'json',
        async: true,
        success: function (dt) {
            basketButton.text(NormalText);

            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserAndBasket").html(dt);
                    toggleBasket();
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }

            GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
        }
    });
}
// End Combine